import axiosInstance from "services/AxiosInstance";
import { TQuestionnaire } from "types";
import { ResponseType } from "types";

export const getQuestionnaireService = async (id?: string): Promise<ResponseType<TQuestionnaire>> => {
  const response = await axiosInstance.get(`questionnaire/${id}`);
  return response.data;
};
